// Libs
import React from 'react'
import _ from 'lodash'

// CSS
import "./styles.scss"

// Env
import env from '../../../../env'

const CaptureFilterSearch = ({ type, placeholder, input }) => {
  return (
    <input
      {...input}
      type={type}
      placeholder={placeholder}
      className="capture-filter-search" />
  )
}

export default CaptureFilterSearch
